import { styled } from '@mui/material';

import logoImage from './av-icon.png';

const StyledTeamLogoContainer = styled('div')({
    width: '20px',
    marginRight: 10,
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
})

const StyledTeamLogo = styled('img')({
    width: '100%'
})

export const TeamLogo = () => {
    // @TODO - replace with proper workspace logo
    return <StyledTeamLogoContainer><StyledTeamLogo src={logoImage} /></StyledTeamLogoContainer>
}